<template>
  <div class="friend-item" @click="handleClick">
    <img :src="friend.imageURL || '/src/assets/avatar_placeholder.png'" class="avatar" />
    <div class="info">
      <div class="name">{{ friend.name }}</div>
      <div class="specifics" v-if="friend.specifics">{{ friend.specifics }}</div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
  friend: {
    type: Object,
    required: true
  }
});

const emit = defineEmits(['remove', 'chat', 'select']);

const handleClick = () => {
  emit('select', props.friend);
};

</script>

<style scoped>

.friend-item {
  display: flex;
  align-items: center;
  background: var(--card-bg, #fff);
  padding: 12px 16px;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.04);
  margin-bottom: 12px;
  transition: all 0.2s ease;
  cursor: pointer;
}

.friend-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
}

.avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 16px;
}

.info {
  flex: 1;
  text-align: left;
}

.name {
  font-weight: 600;
  font-size: 16px;
  color: var(--text-primary, #111);
}

.specifics {
  font-size: 14px;
  color: var(--text-secondary, #666);
  margin-top: 2px;
}


.icon-btn:hover {
  background-color: rgba(0, 0, 0, 0.06);
}



:root[data-theme="dark"] .friend-item {
  background: #2c2c2e;
}

:root[data-theme="dark"] .friend-item:hover {
  background: #3a3a3c;
}

:root[data-theme="dark"] .name {
  color: #ffffff;
}

:root[data-theme="dark"] .specifics {
  color: #aaaaaa;
}

:root[data-theme="dark"] .icon-btn:hover {
  background-color: rgba(255, 255, 255, 0.06);
}

:root[data-theme="dark"] .chat-btn:hover {
  background-color: #3399ff22;
}

:root[data-theme="dark"] .remove-btn:hover {
  background-color: #ff444433;
}

</style>